import script from "./UserProfileFirebase.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileFirebase.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileFirebase.vue?vue&type=style&index=0&id=794f9d0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-794f9d0f"]])

export default __exports__